var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardAvatar = function SvgIconDashboardAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "#3F94FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFD",
    d: "M24.008 23.193c2.879 0 5.357-2.464 5.357-5.674 0-3.17-2.492-5.519-5.357-5.519-2.867 0-5.357 2.4-5.357 5.545 0 3.184 2.49 5.648 5.357 5.648M15.597 35.08h16.822c2.102 0 2.852-.577 2.852-1.707 0-3.312-4.326-7.882-11.263-7.882-6.951 0-11.277 4.57-11.277 7.882 0 1.13.75 1.707 2.866 1.707"
  })));
};
export default SvgIconDashboardAvatar;